import * as React from 'react';

// The Cron Expression trigger, in the trigger set's style (Scheduled, Manual, Timer): the same
// rounded frame as Scheduled, tinted, around an asterisk, the shorthand of a cron expression.
// 2px strokes on the 24px grid, in the set's static grey.
export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="4" y="5" width="16" height="16" rx="2" fill="#fff" />
    <rect x="4" y="5" width="16" height="16" rx="2" fill="#B5BFD2" fillOpacity="0.2" />
    <rect x="4" y="5" width="16" height="16" rx="2" stroke="#B5BFD2" strokeWidth="2" />
    <path
      d="M12.00 8.50L12.00 17.50M8.10 10.75L15.90 15.25M8.10 15.25L15.90 10.75"
      stroke="#B5BFD2"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
